/** @format */

export const TOGGLE_ADD_ACTIVITY_MODAL = "TOGGLE_ADD_ACTIVITY_MODAL";
